export const metadata = {
  teamCreateSuccess: 'settings.team.creation.success',
  teamCreationFailed: 'settings.team.creation.failed',
  getTabChange: (activeTab: string) => `settings.${activeTab}.open`,
  // Team Invite Events
  teamInviteClick: 'settings.team.invite.click',
  teamInviteSuccess: 'settings.team.invite.success',
  teamInviteFailed: 'settings.team.invite.failed',
  teamInviteUpgradeSuccess: 'settings.team.invite.upgrade.success',
  teamInviteUpgradeFailed: 'settings.team.invite.upgrade.failed',
  teamInviteUpdateSuccess: 'settings.team.invite.update.success',
  teamInviteUpdateFailed: 'settings.team.invite.update.failed'
};
